const customerPrivacyAPIInterval = setInterval(() => {
  if (window.Shopify.customerPrivacy) {
    clearInterval(customerPrivacyAPIInterval)

    if (window.Shopify.customerPrivacy.shouldShowBanner()) {
      const hideMarketingAndAnalyticsCheckboxes = () => {
        const marketingCheckbox = document.getElementById('shopify-pc__prefs__marketing');
        const analyticsCheckbox = document.getElementById('shopify-pc__prefs__analytics');
        if (marketingCheckbox && analyticsCheckbox) {
          marketingCheckbox.style.display = 'none';
          analyticsCheckbox.style.display = 'none';
        }
      }

      const managePreferencesButton = document.getElementById('shopify-pc__banner__btn-manage-prefs');

      const hidingInterval = setInterval(()=> {
        if (managePreferencesButton) {
          managePreferencesButton.addEventListener('click', () => {
            setTimeout(hideMarketingAndAnalyticsCheckboxes, 50);
          })
          clearInterval(hidingInterval);
        }
      }, 100);
    }
  }
}, 100)

